import { Link, useNavigate } from "react-router-dom";
import { LOGIN } from "../../api/Api";
import FooterDetails from "../../layout/FooterDetails";
import Logo from "../../components/Logo";
import { useRef } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { LoginSchema } from "../../Validations/SignSchema";
import Cookie from "cookie-universal";
import SubmitAction from "../../components/Auth/Sign/SubmitAction";
import { useAuth } from "../../context/AuthContext";
import { authAxios } from "../../Axios/createAxios";
export default function Login() {
  const queryClient = useQueryClient();
  const cookie = Cookie();
  const navigate = useNavigate();
  const formRef = useRef({});
  const schema = LoginSchema(formRef.current);
  const { checkAuth } = useAuth();
  console.log(formRef.current);
  const {
    register,
    handleSubmit,
    watch,
    getValues,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const form = watch();
  console.log(form);
  console.log(errors);

  const data = async () => {
    try {
      const res = await authAxios.post(`/${LOGIN}`, form);
      console.log(res);

      return res;
    } catch (err) {
      console.log(err);

      throw err?.response?.data?.errors;
    }
  };

  const { mutate, isLoading } = useMutation({
    mutationFn: data,
    onSuccess: (data) => {
      const token = data.data.access_token;

      if (token) {
        cookie.set("bearer", token);
        checkAuth();
      }
      queryClient.invalidateQueries("profile");
      navigate("/query");
      console.log();
    },
    onError: (err) => {
      if (err) {
        formRef.current.email = getValues("email");
        formRef.current.password = getValues("password");
        setError("root", { type: "server", message: "password or email are not correct" });
      }
    },
  });
  const errorMessage = errors ? Object.values(errors)[0]?.message : "";

  const onSubmit = (data) => {
    if (isLoading) return;

    mutate(data);
  };

  return (
    <>
      <div className="container page-h d-flex flex-center align-items-center sign">
        <div className="form-container d-flex  w-50 flex-center flex-column align-items-center justify-content-between p-15 box-shadow">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="d-flex flex-column justify-content-between gap-15 sign-form">
            <div className="input-container gap-30 align-items-center">
              <Logo />
              <input placeholder="email" type="text" {...register("email")} />
              <input type="password" placeholder="Password" {...register("password")} />
            </div>
            <p style={{ textAlign: "center" }}>{errorMessage}</p>
            <Link style={{ alignSelf: "center" }} to={"/password/reset"}>
              forget password
            </Link>
            <SubmitAction isLoading={isLoading} submit={"Log In"} href={"/register"} hrefText={"Sign Up"} />
          </form>
        </div>
      </div>
      <FooterDetails />
    </>
  );
}
